import React from 'react';

const UnhandledError = () => {
  return (
    <div className="flex flex-column align-items-center mt-5 w-full">
      <div className="text-2xl font-bold mb-2">Something went wrong</div>
      <div className="mb-2">Oops! Looks like something went wrong.</div>
      <div className="flex align-items-center">
        Write an email to&nbsp;
        <a
          href="mailto:support@projectsforce.com"
          className="text-primary no-underline"
        >
          support@projectsforce.com
        </a>
        &nbsp;if the issue still persists.
      </div>
    </div>
  );
};

export default UnhandledError;
